export const PRIORITIES = ["Low", "Medium", "High", "Urgent"];

export const STATUSES = ["Not Started", "In Progress", "Done"];

export const CATEGORIES = [
  "Bug Fixing",
  "Developing",
  "Testing",
  "Deployment"
];
